import { Button, Form, message, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import { tdah_questions } from './tdah.catalog'
import { CardHeader, checkEncuesta, EncuestaLoading, InfoCard, NameLabel, onFinishFailed, ThanksMessage } from '../utils'
import { sendDataBody } from '../../resources'

export default function SarsEncuesta({ idpaciente, idmedico, token, visita, session, protocolo }) {

    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'sars', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }

    const onFinish = (values) => {
        console.log('Orginal values: ', values)
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            sars: Object.values(values),
            tipo: 'sars',
            uuid: token,
            visita: visita,
            sesion: session,
            protocolo: protocolo
        }
        console.log('Body:', body);
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };

    const onChange = (e) => {
        console.log('radio checked', e.target.value);
    };



    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage />

    return (
        <div className='parentContainer'>
            <CardHeader title="Escala SARS">
                <NameLabel pacienteData={pacienteData} />

                <NameLabel pacienteData={medicoData} label="Médico: " />

                <InfoCard label="Sesión" value={session} />
            </CardHeader>
            <div className='formContainer'>
                <p>Conteste las siguientes preguntas, midiéndose a sí mismo en cada uno de los criterios mostrados utilizando la escala que se encuentra del lado derecho de la página. Para contestar cada pregunta, marque con una X en el cuadro que mejor describa cómo se ha sentido y comportado en los pasados seis meses. Por favor entregue la lista completa al profesional para discutirla en la sesión de hoy. </p>
                <Form
                    layout='vertical'
                    name="sars_enc"
                    // labelCol={{ span: 24 }}
                    // wrapperCol={{ span: 24 }}
                    initialValues={[]}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >

                    {
                        tdah_questions.map((q, i) => <Form.Item
                            label={q}
                            name={i}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                            ]}
                        >
                            <Radio.Group onChange={onChange} >
                                <Radio value={0}>Nunca</Radio>
                                <Radio value={1}>Raramente</Radio>
                                <Radio value={2}>A veces</Radio>
                                <Radio value={3}>Frecuentemente</Radio>
                                <Radio value={4}>Muy frecuentemente</Radio>
                            </Radio.Group>
                        </Form.Item>)
                    }
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button form='sars_enc' type="primary" htmlType="submit">
                            Enviar respuestas
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
